<template>
  <div class="details-view tab-warning" style="height: 600px !important;">
    <cargo-left-right-resize
      ref="cargoLeftRightResize"
      :left-style="{'max-width':'190px'}"
      :right-style="{'overflow': 'hidden'}"
      style="min-height:90%"
    >
      <template slot="left">
        <div class="main-content">
          <div style="margin: 6px 0px 0px 10px;">
            <cargo-advance-select
              filterable
              :cache="false"
              tag-name="templateName"
              tag-value="uuid"
              :filter-tag-names="['templateName']"
              filter-type="global"
              :default-value="filter.trackingTemplateUuid"
              :static-options="trackingTemplates"
              :placeholder="$t('CargoMsg.Cargo_PleaseSelectAnSOPTemplate')"
              @parentCallBack="changeTrackingTemplate"
            />
          </div>
          <div class="section grid-wrapper">
            <cargo-ag-grid
              :grid-options="leftGridOptions"
              :row-data="leftRowData"
              :show-side-bar="false"
              min-height="100%"
              class="section"
              grid-style="min-width: 240px;width:100%;height:90%;min-height:496px"
              @gridReady="p=>{gridApi=p.api}"
            />
          </div>
        </div>
      </template>
      <template slot="right">
        <div class="main-content">
          <div class="operations">
            <div style="margin: 6px">
              <span :class="showDayWarningClass" @click="changeShowDayWarning">{{ $t('CargoMsg.Cargo_DayWarning') }}</span>
              <span :class="onlyShowNodeClass" @click="changeOnlyShowNode">{{ $t('CargoMsg.Cargo_OnlyDataNodesAreDisplayed') }}</span>
              <el-button no="refresh" type="primary" @click="fetchData('init')">{{ $t('CargoMsg.Cargo_Refresh') }}</el-button>
              <el-button no="moreFilter" type="primary" @click="moreFilter">{{ $t('CargoMsg.Cargo_MoreFilters') }}</el-button>
              <el-button v-show="showDealBtn" no="handled" type="success" @click="onHandled(2)">{{ $t('CargoMsg.Cargo_Handled') }}</el-button>
              <el-button v-show="showDealBtn" no="ignoreMessage" type="danger" @click="onHandled(1)">{{ $t('Sop.ignoreMessage') }}</el-button>
            </div>
          </div>
          <div class="section grid-wrapper">
            <cargo-ag-grid
              config-module="11003"
              :grid-options="gridOptions"
              :column-defs="columnDefs"
              :row-data="rowData"
              grid-style="width:100%;height:90%;min-height:496px"
            />
          </div>
        </div>
      </template>
    </cargo-left-right-resize>
    <div style="min-height: 30px; height: 100%;position: relative">
      <div style="position: absolute; right: 5px;">
        <cargo-pagination
          config-module="11003"
          :total="filter.total || 0"
          :page.sync="filter.pageNum"
          :limit.sync="filter.pageSize"
          @pagination="onPage"
        />
      </div>
    </div>
    <more-filter-dialog
      v-show="filterDialog.visible"
      ref="filterDialog"
      :visible="filterDialog.visible"
      :alert-types="alertTypes"
      :sop-templates="trackingTemplates"
      :lob="lob"
      @close="filterDialog.visible=false"
      @search="handleSearch"
      @changeDate="showDayWarning = false"
      @changeTrackingTemplateKey="changeTrackingTemplateKey"
    />
  </div>
</template>

<script>
import ColumnUtils from '@/utils/ColumnUtils'
import RouterAndPrintRenderer from '@/components/Cargo/Common/routerAndPrintRenderer'
import CargoLeftRightResize from '@/components/Cargo/Common/cargoLeftRightResize'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { getVoyagesByVesselId } from '@/api/seaExport/seaExportJob'
import { handle, queryWarningInfoList, queryWarningInfoLobCount, queryWarningInfoTrackingCount } from '@/api/sop'
import { getLoading } from '@/utils/utilBaseElement'
import { SopUtil } from '@/class/cargo/model/utils/SopUtil'
import MoreFilterDialog from '@/views/dashboard/admin/components/PreWarning/components/moreFilterDialog'
import { DocumentManage } from '@/utils/commonUtil'
import LocalStorageUtils from '@/utils/localStorageUtils'
import CustomLableUtils from '@/utils/CustomLabelUtils'
import { getFilterCacheList } from '@/utils/basicDataCache'
import dateUtils from '@/utils/dateUtils'
import LocalStorageUtilsNew from '@/utils/localStorageUtilsNew'
import { queryTenantAllSopTemplate } from '@/api/sysManage/baseConfig/businessManage'
import { deepClone } from '@/utils'

export default {
  name: 'TabWarning',
  components: { MoreFilterDialog, CargoAdvanceSelect, CargoLeftRightResize },
  props: {
    lob: {
      type: String,
      default: () => 'SE'
    },
    keepState: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      showDayWarning: false,
      onlyShowNode: false,
      documentManage: new DocumentManage(),
      selectTypeNames: TYPE_NAMES,
      showDealBtn: true,
      fullscreenLoading: null,
      voyageNos: [],
      warnRules: [],
      alertTypes: [],
      sopTemplates: [],
      filter: {
        lob: 'SE',
        branchId: 0,
        total: 0,
        pageNum: 1,
        pageSize: 15,
        trackingTemplateUuid: ''
      },
      nodeDataDisplayed: false,
      filterDialog: {
        visible: false
      },
      gridApi: null,
      leftRowData: [],
      leftGridOptions: {
        rowSelection: 'single',
        groupDefaultExpanded: 2,
        defaultColDef: {
          lockPosition: false // 禁止拖动列的位置
        },
        getRowStyle: (params) => {
          const row = params.data
          if (row.trackingCodeColor) {
            console.log('row.trackingCodeColor', row.trackingCodeColor)
            return { 'backgroundColor': '#6abdff' }
          }
        },
        onRowClicked: () => {
          // 点击时清空记录的其它列的颜色
          this.leftRowData.forEach((item) => {
            item.trackingCodeColor = ''
          })
          this.leftRowData = JSON.parse(JSON.stringify(this.leftRowData))
        },
        columnDefs: [{
          headerName: this.$t('Sop.SopWarning'),
          colId: 'trackingName',
          field: 'trackingName',
          width: 180,
          tooltip: (params) => {
            return params.data ? params.data['trackingCode'] : ''
          },
          cellRenderer: (params) => {
            if (params.data.warnState) {
              return `<i class="el-icon-warning"></i>` + params.data.name
            }
            const colorClass = params.data.count > 0 ? 'radio-number has-data' : 'radio-number no-data'
            return `<i class="el-icon-warning"></i><span>${this.isZh ? params.data.trackingName : params.data.trackingEName}</span><span class="${colorClass}"><span class="number"> ${params.data.count}</span></span>`
          }
        }],
        suppressContextMenu: false,
        context: {
          componentParent: this
        },
        onCellClicked: this.leftGridOnCellClicked,
        onCellDoubleClicked: event => {}
      },
      gridOptions: {
        rowSelection: 'multiple',
        onRowSelected: (params) => {
          this.selectedRows = params.api.getSelectedRows()
        },
        frameworkComponents: {
          RouterAndPrintRenderer
        }
      },
      rowData: [],
      searchItems: null,
      searchItemsTxt: '',
      searchItemsCopy: null,
      selectedRows: null,
      loading: null,
      trackingTemplates: [],
      resetQueryOnTemplateSwitch: false // 不根据查询结果数量显示，切换模板时重置查询条件
    }
  },
  computed: {
    showDayWarningClass() {
      return this.showDayWarning ? 'select-data' : 'no-select-data'
    },
    onlyShowNodeClass() {
      return this.onlyShowNode ? 'select-data' : 'no-select-data'
    },
    hasSelected() {
      return this.selectedRows && this.selectedRows.length
    },
    isZh() {
      return this.$store.getters.language === 'zh'
    },
    officeId() {
      return this.$store.getters.currentOfficeId
    },
    isSeaLob() {
      return this.lob === 'SE' || this.lob === 'SI'
    },
    isAirLob() {
      return this.lob === 'AE' || this.lob === 'AI'
    },
    columnDefs() {
      return [
        {
          headerName: '',
          field: 'ignore',
          colId: 'ignore',
          maxWidth: 40,
          cellRenderer: (params) => {
            const methodPath = this.documentManage.getPath('ignore')
            return params.data.warnState !== 0 ? '' : `<span class="el-icon-remove" onclick="${methodPath}('${params.data.uuid}')"></span>`
          }
        },
        {
          headerName: '', width: 32, checkboxSelection: true, sortable: false, suppressMenu: true,
          suppressSizeToFit: true, resizable: false, lockVisible: true,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('SeaExport.BusinessNo'),
          field: 'jobNo',
          colId: 'jobNo',
          width: 100,
          cellRendererSelector: (params) => {
            return ColumnUtils.routeNameByJobLobFun(params, 'lob', 'jobNo', true)
          }
        },
        // 主单号或运单号
        {
          headerName: ['RI', 'RE'].includes(this.lob) ? this.$t('RailwayExport.mbl') : ['IE'].includes(this.lob) ? this.$t('Integrated.Mbl') : this.$t('SeaExport.Mbl2'),
          field: 'mblNo',
          colId: 'mblNo',
          width: 100
        },
        // 关单号
        {
          headerName: this.$t('SeaExport.SoNo'),
          field: 'soNo',
          colId: 'soNo',
          width: 100,
          hide: !(this.lob === 'SE' || this.lob === 'SI'),
          suppressColumnsToolPanel: !(this.lob === 'SE' || this.lob === 'SI')
        },
        // 单证
        {
          headerName: this.$t('SeaExport.Documents'),
          field: 'dcId',
          colId: 'dcId',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        // 客服
        {
          headerName: this.$t('SeaExport.CustomerService'),
          field: 'csrId',
          colId: 'csrId',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_AuthorizedClient'),
          field: 'customerId',
          width: 140,
          cellRenderer: params => ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
        },
        {
          headerName: this.$t('CargoMsg.Cargo_SopTemplate'), field: 'templateName', colId: 'templateName',
          cellRenderer: params => {
            return params.data.warnType === 2 ? this.$t('CargoMsg.Cargo_DataServiceRemind') : params.value
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_SopNode'), field: 'trackingName', colId: 'trackingName'
        },
        {
          headerName: this.$t('CargoMsg.Cargo_WarningConditions'), field: 'condition', colId: 'condition',
          cellRenderer: params => SopUtil.singleWarningConditionsLabelFunc(this.warnRules, params)
        },
        {
          headerName: this.$t('CargoMsg.Cargo_WarningContent'), field: 'content', colId: 'content'
        }, {
          headerName: ['IE'].includes(this.lob) ? this.$t('CargoMsg.Cargo_OrderType') : this.$t('CargoMsg.Cargo_FLCLType'),
          field: 'containerLoadType',
          colId: 'containerLoadType',
          width: 200,
          cellRenderer: (params) => {
            let msg = ''
            if (params.value) {
              const arr = params.value.split(',')
              const result = []
              const cargoTypes = SopUtil.getFLclType(params.data.lob)
              if (cargoTypes) {
                for (const val of arr) {
                  const value = cargoTypes.find(cargoType => String(cargoType.code) === String(val))
                  if (value) {
                    result.push(this.isZh ? value.chineseName : value.englishName)
                  }
                }
              }
              msg = result.join(',')
            }
            return msg
          }
        }, {
          headerName: ['IE'].includes(this.lob) ? this.$t('CargoMsg.Cargo_secondPol') : this.$t('CargoMsg.Cargo_PortOfLoading'),
          field: 'loadingPortCode',
          width: 100,
          cellRenderer: (params) => {
            let type = ''
            if (params.data.lob === 'AE' || params.data.lob === 'AI') {
              type = TYPE_NAMES.basic_data_Airport
            } else {
              type = TYPE_NAMES.basic_data_Seaport
            }
            return ColumnUtils.resolveColumnLabel(type, 'code', params.value, 'englishName')
          }
        }, {
          headerName: ['IE'].includes(this.lob) ? this.$t('CargoMsg.Cargo_secondPod') : this.$t('CargoMsg.Cargo_DestinationPort'),
          field: 'destinationPortCode',
          width: 100,
          cellRenderer: (params) => {
            let type = ''
            if (params.data.lob === 'AE' || params.data.lob === 'AI') {
              type = TYPE_NAMES.basic_data_Airport
            } else {
              type = TYPE_NAMES.basic_data_Seaport
            }
            return ColumnUtils.resolveColumnLabel(type, 'code', params.value, 'englishName')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ChineseFirstVesselName'),
          field: 'vessel',
          colId: 'vessel',
          width: 100
        },
        {
          headerName: this.$t('CargoMsg.Cargo_VoyageFlight'),
          field: 'voyageFlight',
          colId: 'voyageFlight',
          width: 100
        },
        {
          headerName: this.$t('Sop.warningLevel'),
          field: 'level',
          colId: 'level',
          width: 100,
          valueFormatter: params => {
            return SopUtil.warningLevelLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.Status'),
          field: 'warnState',
          colId: 'warnState',
          width: 100,
          valueFormatter: params => {
            return SopUtil.warningStateLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_dispatchingPlace'),
          field: 'dispatchingPlace',
          colId: 'dispatchingPlace',
          hide: !(this.lob === 'IE')
        },
        {
          headerName: this.$t('CargoMsg.Cargo_khPlateNum'),
          field: 'plateNumber',
          colId: 'plateNumber',
          hide: !(this.lob === 'IE'),
          width: 100
        },
        {
          headerName: this.$t('CargoMsg.Cargo_khTrailerNumber'),
          field: 'trailerNumber',
          colId: 'trailerNumber',
          hide: !(this.lob === 'IE'),
          width: 100
        },
        { headerName: this.$t('CargoMsg.Cargo_Sales'), field: 'salesId', width: 180,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Operation'), colId: 'opId', field: 'opId',
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_CustomerServiceOverSea'),
          field: 'overseaOp',
          colId: 'overseaOp',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        {
          headerName: this.$t('Message.Notify'), field: 'notifierIds', colId: 'notifierIds',
          valueFormatter: (params) => {
            return ColumnUtils.getUserDefinedLabel(params.value)
          }
        },
        { headerName: this.$t('Sop.warningAt'), field: 'dateCreated', colId: 'dateCreated', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        { headerName: this.$t('SeaExport.OrderChannels'), field: 'salesChannel', colId: 'salesChannel', width: 150 },
        { headerName: this.$t('SeaExport.Etd'), field: 'etd', colId: 'etd', width: 180,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_ETA'), field: 'eta', colId: 'eta', width: 180, hide: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          },
          suppressColumnsToolPanel: !(this.lob === 'SE' || this.lob === 'SI')
        },
        {
          headerName: this.$t('SeaExport.ContainerDescription'),
          field: 'containerDesc',
          colId: 'containerDesc',
          valueFormatter: (params) => {
            return ColumnUtils.containerDescLabelFunc(params.value)
          },
          hide: true,
          initialWidth: 150,
          suppressColumnsToolPanel: !(this.lob === 'SE' || this.lob === 'SI')
        },
        {
          headerName: this.$t('SeaExport.ShippingCompany'),
          field: 'carrierId',
          colId: 'carrierId',
          hide: true,
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_5') : ''
          },
          width: 200,
          suppressColumnsToolPanel: !(this.lob === 'SE' || this.lob === 'SI')
        }
      ]
    }
  },
  watch: {
    async officeId(newVal, oldVal) {
      if (newVal !== oldVal) {
        await this.initSopTemplate()
        await this.fetchData('init')
      }
    },
    nodeDataDisplayed(val) {
      LocalStorageUtils.setConfiguration('sopWarningNodeDataDisplayed', val)
      this.$nextTick(() => {
        this.fetchData('init')
      })
    },
    showDayWarning(val) {
      LocalStorageUtilsNew.setConfiguration('sopWarningShowDayWarning', val)
    },
    onlyShowNode(val) {
      LocalStorageUtilsNew.setConfiguration('sopWarningOnlyShowNode', val)
    }
  },
  async created() {
    this.activated()
    await this.init()
    console.log('子组件进入created===============')
    setTimeout(async() => {
      await this.fetchData()
    }, 150)
  },
  beforeMount() {
    const context = this
    this.documentManage.set('ignore', function(uuid) {
      context.ignore(uuid)
    })
  },
  activated() {
    this.activated()
  },
  methods: {
    activated() {
      this.resetQueryOnTemplateSwitch = false
      const sopWorkTaskBoardSetting = LocalStorageUtilsNew.getConfiguration('preWarning-setting')
      if (sopWorkTaskBoardSetting) {
        this.resetQueryOnTemplateSwitch = sopWorkTaskBoardSetting.resetQueryOnTemplateSwitch
      }
    },
    async init() {
      const sopConfig = await SopUtil.getInstance()
      this.warnRules = sopConfig.warnDateEnum
      const sopTemplates = sopConfig.templateList
      const lob = this.lob
      if (this.keepState) {
        this.keepState.lob = lob
      }
      this.alertTypes = this.warnRules.filter(item => item.lob === lob && item.warnType === 2)
      this.sopTemplates = sopTemplates.filter(item => item.lob === lob)
      const display = LocalStorageUtils.getConfiguration('sopWarningNodeDataDisplayed')
      this.nodeDataDisplayed = display === '' ? false : display
      const showDayWarning = LocalStorageUtilsNew.getConfiguration('sopWarningShowDayWarning')
      this.showDayWarning = showDayWarning === '' ? true : showDayWarning
      const onlyShowNode = LocalStorageUtilsNew.getConfiguration('sopWarningOnlyShowNode')
      this.onlyShowNode = onlyShowNode === '' ? true : onlyShowNode
      await this.initSopTemplate()

      if (this.$refs['filterDialog']) {
        this.$refs['filterDialog'].initDate(!this.showDayWarning, this.filter.trackingTemplateUuid)
      }
    },
    async fetchData(value) {
      // 如果没获取到模板，则进行模板初始化
      if (value && (!this.trackingTemplates || this.trackingTemplates.length === 0)) {
        await this.init()
      }
      this.filter.lob = this.lob
      this.filter.branchId = this.$store.getters.currentOfficeId
      this.filter.warnState = 0
      if (this.keepState && this.keepState.lob && value !== 'init') {
        this.filter = { ...this.keepState }
        delete this.filter.total
        if (!this.filter.hasOwnProperty('trackingTemplateUuid')) {
          this.filter.trackingTemplateUuid = this.trackingTemplates[0].uuid
        } else {
          if (this.filter.trackingTemplateUuid !== '') {
            // 判断模板是否存在于当前分公司中
            const index = this.trackingTemplates.findIndex(item => item.uuid === this.filter.trackingTemplateUuid)
            if (index === -1) {
              this.filter.trackingTemplateUuid = this.trackingTemplates[0].uuid
            }
          }
        }
        if (this.$refs['filterDialog']) {
          this.$refs['filterDialog'].initDate(!this.showDayWarning, this.filter.trackingTemplateUuid)
        }
      }
      console.info(this.filter)
      this.onQuery(this.filter)
    },
    clearGrid() {
      this.filter.total = 0
      this.filter.pageNum = 1
      this.filter.pageSize = 15
      this.leftGridOptions.api.refreshCells({ force: true })
      this.leftGridOptions.api.clearFocusedCell()
    },
    onQuery(params) {
      this.fullscreenLoading = getLoading('tab-warning')
      // params.dataDisplayed = this.nodeDataDisplayed ? 1 : 0
      if (this.showDayWarning) {
        this.filter.startTime = dateUtils.formatStandardDate(new Date())
        this.filter.endTime = dateUtils.formatStandardDate(new Date())
      } else {
        this.filter.startTime = params.startTime
        this.filter.endTime = params.endTime
      }
      this.filter.dataDisplayed = this.onlyShowNode ? 1 : 0
      sessionStorage.setItem('keepState', JSON.stringify(params))
      const self = this
      const processAlert = this.$t('CargoMsg.Cargo_ViewProcessedAlerts')
      const ignoreAlert = this.$t('CargoMsg.Cargo_ViewIgnoredAlerts')
      Promise.all([
        this.onQueryWarningInfos(params),
        queryWarningInfoLobCount(params).then((res) => {
          self.$emit('resetCount', res.data)
        }),
        this.queryWarningInfoTrackingCountFunc(params, processAlert, ignoreAlert)
      ]).finally(() => {
        this.fullscreenLoading.close()
      })
    },
    async queryWarningInfoTrackingCountFunc(params, processAlert, ignoreAlert) {
      let truckNumMap = null
      if (this.resetQueryOnTemplateSwitch) {
        const totalParam = {
          lob: params.lob,
          branchId: this.$store.getters.currentOfficeId,
          wramState: 0,
          trackingTemplateUuid: params.trackingTemplateUuid,
          dataDisplayed: params.dataDisplayed,
          pageNum: params.pageNum,
          pageSize: params.pageSize,
          total: params.total
        }
        await queryWarningInfoTrackingCount(totalParam).then((res) => {
          const truckCount = res.data
          if (!truckCount || truckCount.length === 0) {
            return
          }
          truckNumMap = new Map()
          for (const item of truckCount) {
            truckNumMap.set(item.trackingCode, item)
          }
        })
      }
      const self = this
      await queryWarningInfoTrackingCount(params).then((res) => {
        let truckCount = res.data
        if (!truckCount || truckCount.length === 0) {
          truckCount = []
        }
        if (truckNumMap) {
          for (const truck of truckCount) {
            const item = truckNumMap.get(truck.trackingCode)
            if (item) {
              truck.count = item.count
            }
          }
        }
        truckCount.push({ warnState: 2, name: processAlert })
        truckCount.push({ warnState: 1, name: ignoreAlert })
        self.leftRowData = truckCount
        self.leftRowData.forEach((item) => {
          if (!params.warnState && params.trackingCode && (item.trackingCode === params.trackingCode)) {
            item.trackingCodeColor = params.trackingCode
          }
          if (!params.warnState && !params.trackingCode && item.warnType === 2 && item.trackingCode === 'remind') {
            item.trackingCodeColor = item.trackingCode
          }
          if (params.warnState && (item.warnState === params.warnState)) {
            item.trackingCodeColor = item.warnState
          }
        })
        if (this.leftGridOptions.api) {
          this.leftGridOptions.api.refreshCells({ force: true })
          this.leftGridOptions.api.clearFocusedCell()
        }
      })
    },
    moreFilter() {
      this.filterDialog.visible = true
    },
    onPage() {
      this.fullscreenLoading = getLoading('tab-warning')
      this.onQueryWarningInfos(this.filter, true)
    },
    onQueryWarningInfos(params, single) {
      sessionStorage.setItem('keepState', JSON.stringify(params))
      const param = deepClone(params)
      // 如果获取数据服务，则不传模板uuid
      if (param.warnType === 2) {
        delete param.trackingTemplateUuid
      }
      queryWarningInfoList(param).then((res) => {
        const pageInfo = res.data
        this.rowData = pageInfo.list
        this.filter.total = pageInfo.total ? Number(pageInfo.total) : 0
      }).finally(() => {
        if (single) {
          this.fullscreenLoading.close()
        }
      })
    },
    // 根据船名查询航次
    onVesselSelectionChange(obj) {
      this.filter[obj.key] = obj.value
      this.filter.voyage = ''
      if (obj.value) {
        getVoyagesByVesselId(obj.vesselId).then(res => {
          this.voyageNos = res.data
        })
      } else {
        this.voyageNos = []
      }
    },
    onHandled(state) {
      const selectedRows = this.getSelectedRows()
      if (selectedRows === null) {
        return
      }
      const msg = state === 1 ? this.$t('CargoMsg.Cargo_IgnoreSelectedData') : this.$t('CargoMsg.Cargo_ProcessSelectedData')
      this.$confirm(msg, this.$t('Message.Prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        const uuids = this.getSelectUuids(selectedRows)
        if (!uuids) {
          this.$message.warning(this.$t('Pricing.NoRecordSelect'))
          return
        }
        this.fullscreenLoading = getLoading('tab-warning')
        handle({ uuid: uuids, warnState: state }).then(res => {
          this.$message.success(this.$t('Message.OperationSuccessfully'))
          this.$nextTick(() => {
            this.onQuery(this.filter)
            this.gridOptions.api.refreshCells({ force: true })
            this.gridOptions.api.clearFocusedCell()
          })
        }).finally(() => {
          this.fullscreenLoading.close()
        })
      })
    },
    // 获取勾选数据
    getSelectedRows() {
      const { api } = this.gridOptions
      const selectedRows = api.getSelectedRows()
      if (selectedRows.length === 0) {
        this.$message.warning(this.$t('Pricing.NoRecordSelect'))
        return null
      }
      return selectedRows
    },
    getSelectUuids(selectedRows) {
      let uuids = []
      selectedRows.forEach(item => {
        if (item.warnState === 0) {
          const ids = item.uuid.split(',')
          uuids = uuids.concat(ids)
        }
      })
      return uuids.join(',')
    },
    handleSearch(val, config) {
      this.filterDialog.visible = false
      Object.assign(this.filter, val)
      if (config && config.length > 0) {
        for (const key of config) {
          if (this.filter.hasOwnProperty(key)) {
            delete this.filter[key]
          }
          if (key === 'createTime') {
            if (this.filter.hasOwnProperty('startTime')) {
              delete this.filter['startTime']
            }
            if (this.filter.hasOwnProperty('endTime')) {
              delete this.filter['endTime']
            }
          }
        }
      }
      this.$nextTick(() => {
        this.filter.pageNum = 0
        this.onQuery(this.filter)
      })
    },
    leftGridOnCellClicked(event) {
      const data = event.data
      const params = this.filter
      // 如果是已处理，已忽略，去除对应按钮
      this.showDealBtn = !(data.warnState === 1 || data.warnState === 2)
      params.warnState = data.warnState || 0
      if (data.warnType === 1 && data.trackingCode) {
        params.trackingCode = data.trackingCode
        if (params.warnType) {
          delete params.warnType
        }
      }
      if (data.warnType === 2) {
        params.warnType = 2
        if (params.trackingCode) {
          delete params.trackingCode
        }
      }
      sessionStorage.setItem('keepState', JSON.stringify(params))
      this.onPage()
    },
    ignore(uuid) {
      this.fullscreenLoading = getLoading('tab-warning')
      handle({ uuid: uuid, warnState: 1 }).then(res => {
        this.$message.success(this.$t('Message.OperationSuccessfully'))
        this.$nextTick(() => {
          this.fetchData()
          this.gridOptions.api.refreshCells({ force: true })
          this.gridOptions.api.clearFocusedCell()
        })
      }).finally(() => {
        this.fullscreenLoading.close()
      })
    },
    changeTrackingTemplate(p) {
      this.filter.trackingTemplateUuid = p.value
      this.$refs['filterDialog'].resetTrackingTemplate(p.value)
      this.onQuery(this.filter)
    },
    changeShowDayWarning() {
      this.showDayWarning = !this.showDayWarning
      if (!this.showDayWarning) {
        this.filter['startTime'] = null
        this.filter['endTime'] = null
      }
      this.$refs['filterDialog'].clearDate(!this.showDayWarning)
      this.onQuery(this.filter)
    },
    changeOnlyShowNode() {
      this.onlyShowNode = !this.onlyShowNode
      this.onQuery(this.filter)
    },
    async initSopTemplate() {
      const isAdmin = this.$store.getters.isAdmin
      const branchId = this.$store.getters.currentOfficeId
      await queryTenantAllSopTemplate().then(res => {
        const list = res.data

        if (!list || list.length === 0) {
          this.trackingTemplates = []
          return
        }
        const trackingTemplates = list.filter((item) => {
          // 管理员不考虑分公司，普通用户关联当前分公司模板
          return item.sopStatus && item.lob === this.lob && (isAdmin || (item.branch === '1' || !item.branch || item.branch.split(',').indexOf(branchId + '') > -1 || item.branch.split(',').indexOf('1') > -1))
        })
        const result = trackingTemplates.sort((a, b) => new Date(b.dateCreated).getTime() - new Date(a.dateCreated).getTime())
        console.info('trackingTemplates', result)
        this.trackingTemplates = result
      })
    },
    changeTrackingTemplateKey(key) {
      this.filter.trackingTemplateUuid = key
    },
    resetFilter() {
      if (this.$refs['filterDialog']) {
        this.$refs['filterDialog'].clear()
      }
    },
    handleFilter() {
      if (this.$refs['filterDialog']) {
        this.$refs['filterDialog'].handleFilter()
      }
    }
  }
}
</script>

<style lang="scss">
  @import "~@/styles/element-variables.scss";
  .tab-warning{
    .el-icon-warning{
      font-size: 14px;
      margin-right: 5px;
    }
    .ag-cell-value{
      padding: 0 40px;
    }
    .radio-number{
      border-radius: 24%;
      height: 18px;
      width: 30px;
      display: inline-block;
      position: absolute;
      right:0;
      top:0;
      margin: 4px;
      .number{
        display: block;
        color: #FFFFFF;
        height: 18px;
        line-height: 18px;
        text-align: center
      }
    }
    .has-data{
      background: #f56c6c;
    }
    .no-data{
      background: #42B983;
    }
    .el-icon-remove{
      font-size: 16px;
      color: $--color-primary;
    }
    .select-data {
      border: 2px solid #006EBE;
      padding: 5px;
      margin-right: 5px;
      color: #006EBE;
      cursor: pointer;
      border-radius: 5px;
      user-select: none; /* 阻止文本被选中和复制 */
    }
    .no-select-data {
      border: 2px solid black;
      padding: 5px;
      margin-right: 5px;
      color: black;
      cursor: pointer;
      border-radius: 5px;
      user-select: none; /* 阻止文本被选中和复制 */
    }
  }
</style>
